import { render, staticRenderFns } from "./PriceCalculationDetails.vue?vue&type=template&id=4f983f6a"
import script from "./PriceCalculationDetails.vue?vue&type=script&lang=js"
export * from "./PriceCalculationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports